export default "__VITE_ASSET__1c36d0d2__"